import { render, staticRenderFns } from "./RecommendApplication.vue?vue&type=template&id=8a1ddd8c&"
import script from "./RecommendApplication.vue?vue&type=script&lang=ts&"
export * from "./RecommendApplication.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports